export default "__VITE_ASSET__8En52c7g__"